import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["marginTopIndicator", "indicatorPosition"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { generateDataTestId } from '../../../internal/utils';
import { useDeviceType } from '../../../responsive';
import { useIsMultiLine } from './useIsMultiLine';
import { calculateMarginTopIndicator } from './utils';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RadioComponent = /*#__PURE__*/React.forwardRef(function Radio(props, ref) {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const {
      marginTopIndicator,
      indicatorPosition = 'center'
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  const {
    disabled,
    invalid,
    label,
    dataTestId
  } = restProps;
  const labelRef = React.useRef(null);
  const needCalculate = indicatorPosition === 'auto';
  const isMultiLine = useIsMultiLine(labelRef, needCalculate);
  const styles = getStyles(deviceType);
  const indicatorPositionIsTop = indicatorPosition === 'top' || indicatorPosition === 'auto' && isMultiLine;
  const marginTopIndicatorValue = calculateMarginTopIndicator({
    isMobile,
    isMultiLine,
    marginTopIndicator,
    indicatorPosition
  });
  return /*#__PURE__*/_jsxs(ControlInputContainer, _objectSpread(_objectSpread({}, restProps), {}, {
    type: "radio",
    className: clsx(styles['radio'], disabled && styles['disabled'], invalid && styles['invalid'], !!label && styles['hasLabel']),
    ref: ref,
    children: [/*#__PURE__*/_jsx("span", {
      className: clsx(styles['indicator'], indicatorPositionIsTop && styles['indicator-top']),
      style: {
        top: "".concat(marginTopIndicatorValue, "px")
      }
    }), label && /*#__PURE__*/_jsx("span", {
      ref: labelRef,
      className: styles['label'],
      "data-testid": generateDataTestId(dataTestId, ['label']),
      children: label
    })]
  }));
});

/**
 * Компонент простого radio с лейблом
 *
 * На телефоне имеет блочный дизайн и radio справа
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=33830-23114&node-type=canvas&t=dWJSsCGr4smKrzpW-0)
 *
 * @export
 * @param {IRadioProps} props
 * @returns
 */
export const Radio = /*#__PURE__*/React.memo(RadioComponent);